module.exports = __webpack_public_path__ + "static/inverted-curved.b49763ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/inverted-curved.svg
// module id = 233
// module chunks = 35783957827783 172322841747965